var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Grid, Input, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { probeLotStatus } from "./CreateNewColumnPurifiedProbeLotModal";
import { CatalogColumnPurifiedProbeLot, CatalogOrganismCustomTargetColumnPurifiedProbeLot, isShortTarget, validationTypes, } from "./ProbeLotTablePage";
var EditColumnPurifiedProbeLotModal = /** @class */ (function (_super) {
    __extends(EditColumnPurifiedProbeLotModal, _super);
    function EditColumnPurifiedProbeLotModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onStatusChange = function (event, data) {
            var str = data.value;
            _this.setState({ status: str });
        };
        _this.onValidationChange = function (event, data) {
            var str = data.value;
            _this.setState({ validation: str });
        };
        _this.onOrderedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ orderedDate: str });
        };
        _this.onReceivedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ receivedDate: str });
        };
        _this.onPurifiedDateChange = function (event, data) {
            var str = data.value;
            _this.setState({ purifiedDate: str });
        };
        _this.onPurifiedByChange = function (_, data) {
            var str = data.value;
            _this.setState({ purifiedBy: str });
        };
        _this.onPurifiedVolumeChange = function (event, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ purifiedVolume: num });
        };
        _this.calculateConcentration = function () {
            if (_this.state.a260OfDilutedSample !== undefined && _this.state.coef !== undefined) {
                if (_this.props.probeLot instanceof CatalogColumnPurifiedProbeLot && isShortTarget(_this.props.probeLot.variant)) {
                    return (_this.state.a260OfDilutedSample / _this.state.coef / _this.props.probeLot.params.probeSetSize * 1000000);
                }
                else {
                    return (_this.state.a260OfDilutedSample / _this.state.coef / _this.props.probeLot.params.probeSetSize / 2 * 1000000);
                }
            }
            else {
                return 'N/A';
            }
        };
        _this.calculateFinalVolume = function () {
            var conc = _this.calculateConcentration();
            if (conc !== 'N/A' && _this.state.purifiedVolume !== undefined && _this.state.targetConcentration !== undefined) {
                return (conc * _this.state.purifiedVolume) / _this.state.targetConcentration;
            }
            else {
                return 'N/A';
            }
        };
        _this.calculateAmountTeAdded = function () {
            var finalVolume = _this.calculateFinalVolume();
            if (finalVolume !== 'N/A' && _this.state.purifiedVolume !== undefined) {
                return (finalVolume - _this.state.purifiedVolume).toFixed(1);
            }
            else {
                return 'N/A';
            }
        };
        _this.onTargetConcentrationChange = function (_, data) {
            var str = data.value;
            if (!str || str.match(/^\d{1,}(\.\d{0,4})?$/)) {
                _this.setState({ targetConcentration: str });
            }
        };
        _this.onA260OfDilutedSampleChange = function (event, data) {
            var str = data.value;
            if (!str || str.match(/^\d{1,}(\.\d{0,4})?$/)) {
                _this.setState({ a260OfDilutedSample: str });
            }
        };
        _this.onCoefChange = function (event, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ coef: num });
        };
        _this.onCurrentInventoryChange = function (event, data) {
            var str = data.value;
            var num = parseFloat(str);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ currentInventory: num });
        };
        _this.onCalculateYieldChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    calculateYield: !oldState.calculateYield
                };
            });
        };
        _this.onDeactivateChange = function (_) {
            _this.setState(function (oldState) {
                return {
                    deactivated: !oldState.deactivated
                };
            });
        };
        _this.onReasonForDeactivationExplanationChange = function (_, data) {
            _this.setState({
                reasonForDeactivation: data.value
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/rna/probe-lot/edit/column-purified/id/" + encodeURIComponent(_this.props.probeLot.id), {
                deactivated: _this.state.deactivated,
                reasonForDeactivation: _this.state.reasonForDeactivation,
                poNumber: _this.state.poNumber,
                supplier: _this.state.supplier,
                createdDate: _this.state.createdDate,
                probeSetSize: _this.props.probeLot.params.probeSetSize,
                purifiedBy: _this.state.purifiedBy,
                targetConcentration: isNaN(parseFloat(_this.state.targetConcentration)) ? null : parseFloat(_this.state.targetConcentration),
                purifiedVolume: _this.state.purifiedVolume,
                a260OfDilutedSample: isNaN(parseFloat(_this.state.a260OfDilutedSample)) ? null : parseFloat(_this.state.a260OfDilutedSample),
                coef: _this.state.coef,
                calculateYield: _this.state.calculateYield,
                currentInventory: _this.state.currentInventory,
                status: _this.state.status,
                orderedDate: _this.state.orderedDate,
                receivedDate: _this.state.receivedDate,
                purifiedDate: _this.state.purifiedDate,
                validation: _this.state.validation,
                checkInventory: _this.props.probeLot.params.checkInventory
            });
        };
        _this.state = {
            deactivated: _this.props.probeLot.deactivated,
            reasonForDeactivation: _this.props.probeLot.reasonForDeactivation,
            poNumber: _this.props.probeLot.params.poNumber,
            supplier: _this.props.probeLot.params.supplier || undefined,
            createdDate: _this.props.probeLot.params.createdDate || undefined,
            status: _this.props.probeLot.params.status,
            orderedDate: _this.props.probeLot.params.orderedDate ? _this.props.probeLot.params.orderedDate : undefined,
            receivedDate: _this.props.probeLot.params.receivedDate ? _this.props.probeLot.params.receivedDate : undefined,
            purifiedDate: _this.props.probeLot.params.purifiedDate ? _this.props.probeLot.params.purifiedDate : undefined,
            validation: _this.props.probeLot.validation,
            purifiedBy: _this.props.probeLot.params.purifiedBy,
            targetConcentration: _this.props.probeLot.params.targetConcentration ? _this.props.probeLot.params.targetConcentration : undefined,
            purifiedVolume: _this.props.probeLot.params.purifiedVolume ? _this.props.probeLot.params.purifiedVolume : undefined,
            a260OfDilutedSample: _this.props.probeLot.params.a260OfDilutedSample ? _this.props.probeLot.params.a260OfDilutedSample : undefined,
            coef: _this.props.probeLot.params.coef ? _this.props.probeLot.params.coef : undefined,
            calculateYield: !!_this.props.probeLot.params.lotYield,
            currentInventory: _this.props.probeLot.params.currentInventory ? _this.props.probeLot.params.currentInventory : undefined,
        };
        return _this;
    }
    EditColumnPurifiedProbeLotModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.status === 'CREATED' && prevState.status !== 'CREATED') {
            this.setState({ createdDate: prevState.createdDate || new Date().toISOString().split('T')[0] });
        }
        if (this.state.status === 'ORDERED' && prevState.status !== 'ORDERED') {
            this.setState({
                orderedDate: prevState.orderedDate || new Date().toISOString().split('T')[0],
                poNumber: prevState.poNumber,
                supplier: prevState.supplier
            });
        }
        if (this.state.status === 'RECEIVED' && prevState.status !== 'RECEIVED') {
            this.setState({
                receivedDate: prevState.receivedDate || new Date().toISOString().split('T')[0],
                coef: prevState.coef
            });
        }
        if (this.state.status === 'PROBES_PURIFIED' && prevState.status !== 'PROBES_PURIFIED') {
            this.setState({
                purifiedDate: prevState.purifiedDate || new Date().toISOString().split('T')[0],
                purifiedBy: prevState.purifiedBy,
                targetConcentration: prevState.targetConcentration || 1.25,
                a260OfDilutedSample: prevState.a260OfDilutedSample
            });
        }
    };
    EditColumnPurifiedProbeLotModal.prototype.render = function () {
        var _this = this;
        var probeLotType;
        if (this.props.probeLot instanceof CatalogColumnPurifiedProbeLot) {
            probeLotType = 1;
        }
        else if (this.props.probeLot instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot) {
            probeLotType = 2;
        }
        else {
            probeLotType = 3;
        }
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/lotNumber', labelContent: 'Probe Lot Number' },
                React.createElement(Input, { value: this.props.probeLot.lotNumber, disabled: true })),
            probeLotType === 1 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Catalog Entry', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Organism' },
                        React.createElement(Input, { value: this.props.probeLot.organism, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.geneSymbol, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Accession' },
                        React.createElement(Input, { value: this.props.probeLot.accession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.sequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.probeSetSize, disabled: true }))),
            probeLotType === 2 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Catalog Organism Custom Target', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Organism' },
                        React.createElement(Input, { value: this.props.probeLot.organism, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Custom Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.customGeneSymbolName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Custom Accession' },
                        React.createElement(Input, { value: this.props.probeLot.customAccession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Custom Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.customSequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customVariantName', labelContent: 'Custom Variant Name' },
                        React.createElement(Input, { value: this.props.probeLot.customVariantName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Custom Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Custom Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.customProbeSetSize, disabled: true }))),
            probeLotType === 3 &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeLotType', labelContent: 'Probe Lot Type' },
                        React.createElement(Input, { value: 'Custom', disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/organism', labelContent: 'Custom Organism' },
                        React.createElement(Input, { value: this.props.probeLot.customOrganismName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/geneSymbol', labelContent: 'Custom Gene Symbol' },
                        React.createElement(Input, { value: this.props.probeLot.customGeneSymbolName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/accession', labelContent: 'Custom Accession' },
                        React.createElement(Input, { value: this.props.probeLot.customAccession, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/sequence', labelContent: 'Custom Sequence' },
                        React.createElement(Input, { value: this.props.probeLot.customSequence, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customVariantName', labelContent: 'Custom Variant Name' },
                        React.createElement(Input, { value: this.props.probeLot.customVariantName, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amplifier', labelContent: 'Custom Amplifier' },
                        React.createElement(Input, { value: this.props.probeLot.hcrAmplifier.id, disabled: true })),
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/probeSetSize', labelContent: 'Custom Probe Size' },
                        React.createElement(Input, { value: this.props.probeLot.customProbeSetSize, disabled: true }))),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/status', labelContent: 'Probe Lot Status' },
                React.createElement(Select, { options: probeLotStatus.map(function (s) {
                        return {
                            text: s,
                            value: s
                        };
                    }), placeholder: this.props.probeLot.params.status, onChange: this.onStatusChange, value: this.state.status, disabled: !!this.props.probeLot.params.lotYield })),
            this.state.status === 'CREATED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/createdDate', labelContent: 'Created Date' },
                    React.createElement(Input, { onChange: function (_, data) { return _this.setState({ createdDate: data.value }); }, placeholder: 'Date', type: "date", value: this.state.createdDate })),
            this.state.status === 'ORDERED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/orderedDate', labelContent: 'Ordered Date' },
                    React.createElement(Input, { onChange: this.onOrderedDateChange, placeholder: 'Date', type: "date", value: this.state.orderedDate })),
            this.state.status === 'RECEIVED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/receivedDate', labelContent: 'Received Date' },
                    React.createElement(Input, { onChange: this.onReceivedDateChange, placeholder: 'Date', type: "date", defaultValue: new Date().toISOString().split('T')[0], value: this.state.receivedDate })),
            this.state.status === 'PROBES_PURIFIED' &&
                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/purifiedDate', labelContent: 'Purified Date' },
                    React.createElement(Input, { onChange: this.onPurifiedDateChange, placeholder: 'Date', type: "date", defaultValue: new Date().toISOString().split('T')[0], value: this.state.purifiedDate })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/validation', labelContent: 'Validation' },
                React.createElement(Select, { options: validationTypes.map(function (v) {
                        return {
                            text: v,
                            value: v
                        };
                    }), placeholder: this.props.probeLot.validation, onChange: this.onValidationChange, value: this.state.validation })),
            this.state.status === 'ORDERED' &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/poNumber', labelContent: 'PO Number' },
                            React.createElement(Input, { onChange: function (_, data) { return _this.setState({ poNumber: data.value }); }, placeholder: 'PO#', type: "text", value: this.state.poNumber })),
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/supplier', labelContent: 'Supplier' },
                            React.createElement(Select, { options: this.props.suppliers.map(function (s) { return ({ text: s, value: s }); }), placeholder: 'Supplier', onChange: function (_, data) { return _this.setState({ supplier: data.value }); }, value: this.state.supplier || '', clearable: true })))),
            (this.state.status === 'RECEIVED' || this.state.status === 'PROBES_PURIFIED') &&
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/poNumber', labelContent: 'PO Number' },
                                React.createElement(Input, { onChange: function (_, data) { return _this.setState({ poNumber: data.value }); }, placeholder: 'PO#', type: "text", value: this.state.poNumber, disabled: true })),
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/supplier', labelContent: 'Supplier' },
                                React.createElement(Select, { options: this.props.suppliers.map(function (s) { return ({ text: s, value: s }); }), placeholder: 'Supplier', onChange: function (_, data) { return _this.setState({ supplier: data.value }); }, value: this.state.supplier || '', clearable: true, disabled: true })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/coef', labelContent: 'Average Coefficients' },
                                React.createElement(Input, { onChange: this.onCoefChange, placeholder: 0, value: this.state.coef, disabled: this.state.status === 'PROBES_PURIFIED' }))))),
            this.state.status === 'PROBES_PURIFIED' &&
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/purifiedBy', labelContent: 'Purified By' },
                                React.createElement(Input, { onChange: this.onPurifiedByChange, value: this.state.purifiedBy, disabled: !!this.props.probeLot.params.lotYield }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/targetConcentration', labelContent: 'Target Concentration (µM)' },
                                React.createElement(Input, { type: 'text', onChange: this.onTargetConcentrationChange, placeholder: 0, value: this.state.targetConcentration, disabled: !!this.props.probeLot.params.lotYield })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/a260OfDilutedSample', labelContent: 'A260 Of Diluted Sample' },
                                React.createElement(Input, { type: 'text', onChange: this.onA260OfDilutedSampleChange, placeholder: 0, value: this.state.a260OfDilutedSample, disabled: !!this.props.probeLot.params.lotYield }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/purifiedVolume', labelContent: 'Purified Volume (µL)' },
                                React.createElement(Input, { onChange: this.onPurifiedVolumeChange, placeholder: 0, value: this.state.purifiedVolume, disabled: !!this.props.probeLot.params.lotYield })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/concentration', labelContent: 'Purified Concentration (µM)' },
                                React.createElement(Input, { value: this.calculateConcentration() }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/finalVolume', labelContent: 'Final Volume (µL)' },
                                React.createElement(Input, { value: this.calculateFinalVolume() })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/amountTeAdded', labelContent: 'Amount TE to Add (µl)' },
                                React.createElement(Input, { value: this.calculateAmountTeAdded() })))),
                    this.props.probeLot.params.lotYield &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/yield', labelContent: 'Lot Yield (pmol)' },
                                        React.createElement(Input, { placeholder: 0, value: this.props.probeLot.params.lotYield, disabled: true }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/currentInventory', labelContent: 'Current Inventory' },
                                        React.createElement(Input, { onChange: this.onCurrentInventoryChange, placeholder: 0, value: this.state.currentInventory }))))),
                    (!this.props.probeLot.params.lotYield && this.props.probeLot.params.checkInventory) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(Checkbox, { checked: this.state.calculateYield, label: "Calculate Yield", onChange: this.onCalculateYieldChange }))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/currentInventory', labelContent: 'Current Inventory' },
                                        React.createElement(Input, { onChange: this.onCurrentInventoryChange, placeholder: 0, value: this.state.currentInventory }))))),
                    (!this.props.probeLot.params.lotYield && !this.props.probeLot.params.checkInventory) &&
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null,
                                React.createElement(Checkbox, { checked: this.state.calculateYield, label: "Calculate Yield", onChange: this.onCalculateYieldChange })))),
            React.createElement(Grid, { columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Checkbox, { checked: this.state.deactivated, label: "Deactivate", onChange: this.onDeactivateChange })),
                    this.state.deactivated &&
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/reasonForDeactivation', labelContent: 'Reason for Deactivation' },
                                React.createElement(Input, { onChange: this.onReasonForDeactivationExplanationChange, value: this.state.reasonForDeactivation })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save Edits', labelPosition: 'left', onClick: this.submit, positive: true })))));
    };
    return EditColumnPurifiedProbeLotModal;
}(React.PureComponent));
export default EditColumnPurifiedProbeLotModal;
//# sourceMappingURL=EditColumnPurifiedProbeLotModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditColumnPurifiedProbeLotModal.js
// module id = 1246
// module chunks = 0